"use client"

import React, { useRef } from "react";
import styles from "./VideoCard.module.scss";
import PlayIcon from "@/SvgIcons/PlayIcon";
import { imgPathReplace } from "@/helpers/imgPathReplace";
interface TestimonialProps {
  id : string;
  testimonial : any;
  activeVideoId: string | null; 
  ssetActiveVideoId: (id: string | null) => void; 
  isMobile :boolean;
}

const Testimonial: React.FC<TestimonialProps> = ({ id, testimonial, activeVideoId,isMobile,
    ssetActiveVideoId }) => {
    const {name, title, image, video} = testimonial;
    const isPlaying = activeVideoId === id;
    const videoRef = useRef<HTMLVideoElement | null>(null); 
    const handlePlayClick = () => {
      if (isPlaying) {
        ssetActiveVideoId(null);
      } else {
        ssetActiveVideoId(id);
        if (videoRef.current) {
          videoRef.current.play();
        }
      }
    };

  const handleVideoEnd = () => {
    ssetActiveVideoId(null); 
  }; 

  return (
    <div id= {`video-card-${id}`} className={styles.testimonialItem}>
      <div className={`${styles.testimonialCard} ${isPlaying ? styles.playing : ''}`}>
        {!isPlaying ? (
          <div className={styles.testimonialThumbnail} >
            <img 
            src={imgPathReplace(image)} 
            srcSet={imgPathReplace(image)} 
            alt={name||"Amity Online"} 
            title={name||"Amity Online"}
            width={isMobile? 176.5 :353}
            height={isMobile? 313.5 :627}
            loading="lazy"
            className={styles.w100} />
            <div id= {`videocard-button-${id}`} className={styles.playBtnOverlay} onClick={handlePlayClick}>
              <PlayIcon />
            </div>
          </div>
        ) : (
          <div className={styles.testimonialVideo}>
            <video
              ref={videoRef}
              src={video}
              controls
              autoPlay
              className={styles.w100}
              onEnded={handleVideoEnd}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonial;
